function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomSeparateBathToiletFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 2v28h2V2h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.887 13c-.292-1.437-1.154-2.737-2.668-2.965C23.534 9.37 24.148 9 24.8 9c.633 0 1.152.228 1.522.643.377.422.678 1.128.678 2.211V28h-8v2h11v-2h-1V11.854c0-1.45-.408-2.672-1.186-3.543C27.03 7.43 25.948 7 24.8 7c-1.994 0-3.503 1.504-3.76 3.475-.922.552-1.582 1.517-1.873 2.525-.11.378-.167.763-.167 1.133V15h7v-.867c0-.376-.037-.759-.113-1.133zm-3.149-1c.37 0 .602.136.818.453.102.15.192.336.264.547h-2.5c.073-.13.158-.256.254-.373.358-.436.762-.627 1.164-.627zM2 15h5v7h6v1.415c0 1.832-1.057 3.36-2.582 4.009V30H3.027v-3.657A4.608 4.608 0 012.036 24H2v-9zm2 7h1v-5H4v5zm.063 2c.106.485.341.922.674 1.258l.29.292V28h3.39v-2.125l.802-.163c.821-.166 1.507-.806 1.716-1.712H4.063z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21H8v-2h5v2zM20.495 18H19v-2h1.495v2zM21.752 18h1.495v-2h-1.495v2zM24.505 18H26v-2h-1.495v2z",
    fill: props.color
  }));
}

export default SvgIconRoomSeparateBathToiletFilled;